import { useTranslation } from 'react-i18next';

import { Card, CardContent, Grid, Stack, Text } from '@shared/ui';
import { StudentSectionTabs } from './StudentSectionTabs';

export function StudentDashboardPage() {
  const { t } = useTranslation();

  return (
    <Stack gap="lg">
      <StudentSectionTabs />

      <Grid cols={3} gap="lg" className="grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        <MetricCard title={t('student.enrolledCourses')} value="0" />
        <MetricCard title={t('student.completed')} value="0" />
        <MetricCard title={t('student.certificates')} value="0" />
      </Grid>

      <Card className="border-dashed">
        <CardContent className="p-8 text-center">
          <Text color="muted">{t('student.emptyState')}</Text>
        </CardContent>
      </Card>
    </Stack>
  );
}

function MetricCard({ title, value }: { title: string; value: string }) {
  return (
    <Card>
      <CardContent className="p-6">
        <Text size="sm" color="muted">
          {title}
        </Text>
        <Text className="mt-2 text-3xl font-bold text-card-foreground">{value}</Text>
      </CardContent>
    </Card>
  );
}
